import { combineReducers } from 'redux';

import { config as configReducer } from './config';
import { content as contentReducer } from './content';
import { player as playerReducer } from './player';
import { search as searchReducer } from './search';

const rootReducer = combineReducers({
  config: configReducer,
  content: contentReducer,
  player: playerReducer,
  search: searchReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js